import { render, staticRenderFns } from "./queuePause.vue?vue&type=template&id=1b4d610f&"
import script from "./queuePause.vue?vue&type=script&lang=js&"
export * from "./queuePause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports